import React from 'react';
import DatePicker from 'react-datepicker';
import { de, frCH, itCH, enUS } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import i18n from 'utils/i18n';

const HighlightedDatePicker = ({ selected, onChange, ...props }) => {
	const today = new Date();
	const getLocale = language => {
		switch (language) {
			case 'de':
				return de;
			case 'fr':
				return frCH;
			case 'it':
				return itCH;
			case 'en_US':
			default:
				return {
					...enUS,
					options: {
						...enUS.options,
						weekStartsOn: 1, // 0 is Sunday, 1 is Monday
					},
				};
		}
	};

	return (
		<DatePicker
			selected={selected}
			onChange={onChange}
			minDate={today}
			locale={getLocale(i18n.language)}
			dateFormat="dd.MM.yyyy"
			preventOpenOnFocus
			isClearable
			{...props}
		/>
	);
};

export default HighlightedDatePicker;
